
import './styles/App.css';
import mypageimg from './img/Ellipse 1.png';
import Topknee from './img/ant-design_setting-twotone.png';
import Carinfo from './img/mdi_car-info.png'
import Coupon from './img/bx_bxs-coupon.png'
import Mypro from './img/bx_bxs-coupon-2.png'
import Bag from './img/ic_round-home-repair-service.png'
import Danger from './img/gg_danger.png'
import CExample from './img/Rectangle\ 46.jpg'
import Pcall from './img/fluent_person-call-16-filled.png'
import RightArrow from './img/ic_round-arrow-forward-ios.png'
import Setting from './img/ant-design_setting-twotone.png';
import axios from 'axios';
import { instance } from './common';
import React,{useEffect,useState} from 'react';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';



function Mypagemain({history}) {
    let session = JSON.parse(window.sessionStorage.result);
    let {u_login_id,u_type,u_uuid} = session;

    
  const [data, setData] = useState({});
  

  let obj = {
    u_login_id:u_login_id,  
  }
  useEffect(() => {
    
    const fetchData = async () => {
      instance.post('/users/id',obj).then(function(res){
            setData(res.data[0]);
        });
    
    };

    fetchData();

  }, []);

  
  console.log('data', data)
  const {u_nick} = data;

    const marginB = {
        marginBottom:'3px'
    }

    const junbi = () => {
        alert('준비중입니다.');
    }

    const goLogout = () => {
      const {u_social} = JSON.parse(window.sessionStorage.result);
      history.push('/Logout?kind='+u_social);
  }
  return (
    <>
      <div className="cotainer mt-5">
          <div className="row mypage-header">
                <div className="col-12 text-center">
                    {
                      u_uuid
                      ?<div className="mypage_img d-inline-block" style={{background:'url(\''+u_uuid+'\')'}}></div>
                      :<div className="mypage_img d-inline-block"></div>
                    }
                    <br />
                    <div className="d-inline-block"><span>{u_nick}</span><img className="main_topknee" src={Topknee} style={marginB} onClick={() => history.push('/mypageedit')}/>
                    </div>
                </div>
          </div>
      </div>
      <div>
      <div className="row p-3 mp_page-menu" onClick={() => history.push('/represent')}>
          <div className="col-2"><img className="car_info" src={Carinfo} /></div>
          <div className="col-8 p-2">내 차량 관리</div>
          <div className="col-2 p-2"><img className="mp_rightarrow" src={RightArrow}></img></div>
      </div>
      <div className="row p-3 mp_page-menu" onClick={() => history.push('/myReserve')}>
          <div className="col-2"><img className="car_info" src={Mypro} /></div>
          <div className="col-8 p-2">서비스 예약 내역</div>
          <div className="col-2 p-2"><img className="mp_rightarrow" src={RightArrow}></img></div>
      </div> 
        
        <div className="row p-3 mp_page-menu" onClick={() => history.push('/noticelist')}>
            <div className="col-2"><img className="car_info" src={Danger} /></div>
            <div className="col-8 p-2">공지사항</div>
            <div className="col-2 p-2"> <img className="mp_rightarrow" src={RightArrow}></img></div>
        </div>
        <div className="row p-3 mp_page-menu" onClick={() => history.push('/faqlist')}>
            <div className="col-2"><img className="car_info" src={Pcall} /></div>
            <div className="col-8 p-2">고객센터</div>
            <div className="col-2 p-2"><img className="mp_rightarrow" src={RightArrow}></img></div>
        </div>
        <div className="row p-3 mp_page-menu" onClick={() => goLogout()}>
            <div className="col-2"><img className="car_info" src={Setting} /></div>
            <div className="col-8 p-2">로그아웃</div>
            <div className="col-2 p-2"><img className="mp_rightarrow" src={RightArrow}></img></div>
        </div>
      </div>
    </>
  );
}

export default Mypagemain;